<template>
    <a
        href="/"
        :class="{
            'header-logo': true,
            [classList]: !!classList,
        }"
    >
        <slot>Банк ДОМ.РФ - универсальный ипотечно-строительный банк</slot>
        <template v-if="lang === 'ru'">
            <div
                v-if="isLoading"
                class="header-logo__container"
            >
                <div class="header-logo__placeholder" />
            </div>
            <template v-else-if="htmlContent">
                <div
                    v-if="dark"
                    v-html="htmlContent.dark"
                    class="header-logo__container"
                />
                <div
                    v-else
                    v-html="htmlContent.light"
                    class="header-logo__container"
                />
            </template>
            <template v-else>
                <div class="header-logo__container">
                    <img
                        :src="dark ? '/local/templates/redesign/src/assets/img/logo-main-white.svg' : '/local/templates/redesign/src/assets/img/logo-main.svg'"
                        alt="Логотип Банк ДОМ.РФ"
                        class="header-logo__img"
                    >
                </div>
            </template>
        </template>
        <div v-else class="header-logo__container">
            <img
                src="/local/templates/redesign/src/assets/img/logo-eng.svg"
                alt="Bank DOM.RF"
                class="header-logo__img-eng"
            >
        </div>
    </a>
</template>
<script>
import { ref } from 'vue';
import { getCustomLogo } from '../../api/logo';

export default {
    name: 'HeaderLogo',
    props: {
        dark: Boolean,
        lang: {
            type: String,
            default: 'ru',
            validator: (val) => ['eng', 'ru', 'cn'].includes(val),
        },
        classList: String,
    },
    setup() {
        const htmlContent = ref(null);
        const isLoading = ref(false);

        if (window.config.frontend.useCustomLogo) {
            isLoading.value = true;
            getCustomLogo()
                .then((res) => {
                    htmlContent.value = res;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }      

        return {
            htmlContent,
            isLoading,
        };
    },
};
</script>
<style lang="scss">
@import "../../assets/scss/base/variables";
@import "../../assets/scss/base/mixins";
@import "../../assets/scss/base/functions";

.header-logo {
    width: auto;
    @include fluid('height', 40px, 32px);
    @include fluid('margin-right', 43px, 20px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 0;

    &__img-eng	{
        max-width: 100%;
        width: 6.875em;
        height: 2.5em;
        object-fit: contain;
    }

    &__container {
        @include fluid('font-size', 16px);
    }

    &__placeholder {
        position: relative;
        width: 6.875em;
        height: 2.5em;
    }

    &__img {
        max-width: 100%;
        width: 6.875em;
        height: 2.5em;
        object-fit: contain;
    }
}
</style>
